import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { PageConfigService } from 'src/app/page-config.service';
import { Component, OnInit, HostListener, ViewChild, EventEmitter, Output } from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import { setDefaultService } from 'selenium-webdriver/edge';

@Component({
  selector: 'app-offline-header',
  templateUrl: './offline-header.component.html',
  styleUrls: ['./offline-header.component.scss']
})
export class OfflineHeaderComponent implements OnInit {

  constructor(public translate: TranslateService, private cookieService: CookieService, private PageConfigService: PageConfigService, private router : Router) {
    //  img = this.PageConfigService.configValue.header_img_src
     this.PageConfigService.config.subscribe((x) =>{this.marque = x;
       this.img = x.header_img_src; this.old_link = x.old_link; this.header_url = x.header_url})

       // translate
       translate.addLangs(['fr', 'en', 'es']);
       translate.setDefaultLang('fr');
   
       const browserLang = translate.getBrowserLang();
       console.log(translate)
       translate.use(browserLang.match(/fr|en|es|ca/) ? browserLang : 'fr');
   }



   locales = [
    { label: '🇫🇷', value: 'fr' },
    { label: '🇺🇸', value: 'en' },
    { label: '🇪🇸', value: 'es' },
    { label: 'ca', value: 'ca' },
  ];


  isMobile : boolean

   marque: any;
   img :string;
   old_link :string;
   header_url :string;

  @Output() menuEmit = new EventEmitter<boolean>();

  public MenuAction() {
    this.menuEmit.emit(true);
  }

  public isMobileDivice; 
  setDevice() {
    if (this.innerWidth <= 768) {
      this.isMobileDivice = false;
      return;
    }
    this.isMobileDivice =  true;
  }

  public innerWidth: any;
  ngOnInit() {
      this.innerWidth = window.innerWidth;
      this.setDevice();

      if( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i))
      {
        this.isMobile = true
      }else{
        this.isMobile = false
      }
    

    }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.setDevice();

  }


  refresh(){

    this.router.navigate(['/']).then(ok => {
      window.location.reload();
    });

  }

  isLogin(){
    if(localStorage.getItem('token_clem_mobi')) 
    { return true}
    else{
     return false
    }
   }
 


}
